module.exports = __webpack_public_path__ + "static/media/video.b9835a62.ogg";